import type { Resource } from '../../';
export const account_wishlist_title: Resource = {"default":"Wishlist"};
